import Button from "@mui/material/Button";
import { withStyles } from "@mui/styles";



const _errorTextButtonStyles = (theme) => ({
    root: {
        color: theme.palette.error.main,
    },
});
const _errorOutlinedButtonStyles = (theme) => ({
    root: {
        color: theme.palette.error.main,
        borderColor: theme.palette.error.light,
    },
});
const _confirmButtonStyles = (theme) => ({
    root: {
        color: theme.palette.secondary.main,
    },
});

export const ErrorTextButton = withStyles(_errorTextButtonStyles)(Button);
export const ErrorOutlinedButton = withStyles(_errorOutlinedButtonStyles)(Button);
export const ConfirmTextButton = withStyles(_confirmButtonStyles)(Button);
